import { cardStyle } from './ActionCard.styles';
import { PropsWithChildren } from 'react';

export function ActionCard({ children }: PropsWithChildren) {
  return <div className={cardStyle} children={children} />;
}
